import { ChangeDetectionStrategy, Component, computed, contentChildren } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MenubarModule } from 'primeng/menubar';
import { MenubarItemComponent } from '../menubar-item/menubar-item.component';

@Component({
  selector: 'nsp-menubar',
  templateUrl: './menubar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MenubarModule],
})
export class MenubarComponent {
  menubarItems = contentChildren(MenubarItemComponent);

  primeNgItems = computed<MenuItem[]>(() =>
    this.menubarItems().map(({ label, url, icon }): MenuItem => ({ label: label(), routerLink: url(), icon: icon() }))
  );
}
